import BoSungThongTin from './BoSungThongTin.jsx';
import BoSungThongTinChuyenDon from './BoSungThongTinChuyenDon.jsx'

export {
  BoSungThongTin,
  BoSungThongTinChuyenDon
}


// WEBPACK FOOTER //
// ./src/components/modules/bo-sung-thong-tin/index.js